import React from "react";
import {
  Calendar,
  Callout,
  DayOfWeek,
  DefaultButton,
  DirectionalHint,
  Dropdown,
  FocusTrapZone,
  IDropdownOption,
  Spinner,
  SpinnerSize,
  Stack,
  Text,
} from "@fluentui/react";
import { getCustomerReportStatusCount } from "../../services/dashboard/DashboardService";
// import { getAllDataCenters } from "../../services/datacenter/DatacenterService";
import { ICustomerReportStatusCount, IDataCenter } from "../../vm";
import { ToastContext } from "../common/ToastProvider";
// import { Loading } from "../../services/Loading";
import { childrenGap, DayPickerStrings } from "../common/Constants";
import moment from "moment";
import ReportStatusCard from "./ReportStatusCard";
import { useHistory } from "react-router";
import { parseJwt } from "../../services/UtilService";

export interface ReportStatusDashboardProps {
  datacenters: IDataCenter[];
  cemUsers: IDropdownOption[];
}
let calendarButtonElement: HTMLElement;
const wrapperStyles = {
  // width: "100%",
  // maxWidth: 980,
  margin: "0 auto",
};

const ReportStatusDashboard: React.FC<ReportStatusDashboardProps> = ({
  datacenters,
  cemUsers
}) => {
  // custom hooks
  const history = useHistory();
  const { showToast } = React.useContext(ToastContext);
  const tokenData = parseJwt();

  // const date = new Date();
  // // date.setMonth(date.getMonth() - 1);
  // const dateString = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;
  // console.log("datestring", dateString);

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    customerReportStatus: {
      count: [],
      totalReport: 0,
    },
    searchObj: {
      date: moment().subtract(1, "month").toDate(),
      datacenterIds: tokenData.role === 2 ? ['all'] : datacenters.length > 0 ? [datacenters[0]?._id] : [],
      cemIds: tokenData.role === 2 ? [tokenData._id] : ['all']
    },
    allDatacenters: [],
    datacenterOptions: [],
    selectedDatacenter: tokenData.role === 2 ? ['all'] : datacenters.length > 0 ? datacenters[0]?._id : "",
    showCallender: false,
    cemUserOptions: []
  } as {
    isLoading: boolean;
    customerReportStatus: ICustomerReportStatusCount;
    searchObj: {
      date: Date | string;
      datacenterIds: string[];
      cemIds: string[];
    };
    allDatacenters: IDataCenter[];
    datacenterOptions: IDropdownOption[];
    cemUserOptions: IDropdownOption[];
    selectedDatacenter: string;
    showCallender: boolean;
  });

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getCustomerReportStatus();
    };
    asyncFunc();
  }, []);

  const getCustomerReportStatus = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...paramState };
    }
    setState({ ...localState, isLoading: true });
    let searchObj = { ...localState.searchObj };
    searchObj.date = moment(searchObj.date).format("YYYY-MM-DD");

    let datacenterOptions: IDropdownOption[] = [];
    if (datacenters.length > 0) {
      datacenters.forEach((d) => {
        datacenterOptions.push({
          key: d._id as string,
          text: d.name,
        });
      });
    }
    if (tokenData.isAdmin && [0, 2, 5].includes(tokenData.role)) {
      datacenterOptions.unshift({ key: 'all', text: 'All' });
    }
    let cemUserOptions = [...cemUsers];
    if (tokenData.isAdmin && (tokenData.role === 0 || tokenData.role === 5)) {
      cemUserOptions.unshift({ key: 'all', text: 'All' });
    }

    let result = await getCustomerReportStatusCount({ ...searchObj, datacenterIds: searchObj.datacenterIds.includes('all') ? [] : searchObj.datacenterIds, cemIds: searchObj.cemIds.includes('all') ? [] : searchObj.cemIds });
    if (result?.success) {
      let count: Array<{ _id: number; count: number }> = [];
      [0, 1, 2, -2, 3, -3, 4, -4, 5].forEach((ele) => {
        if (ele < 0) return;
        let item = result.data.count.find((c) => c._id === ele);
        if (item) {
          count.push(item);
        } else {
          count.push({
            _id: ele,
            count: 0,
          });
        }
      });
      console.log("count", count);

      setState({
        ...localState,
        customerReportStatus: {
          totalReport: result.data.totalReport || 0,
          count,
        },
        // searchObj,
        datacenterOptions,
        cemUserOptions
        // selectedDatacenter:
        //   datacenters.length > 0 ? (datacenters[0]?._id as string) : "",
      });
    } else {
      setState({ ...localState, isLoading: false });
      showToast(
        result?.message || "Error while getting customer report status",
        "error"
      );
    }
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  const viewCustomers = (status: number) => {
    history.push(
      `/customers?from=${0}&to=${12}&search=${""}&date=${moment(
        state.searchObj.date
      ).format(
        "MM/DD/YYYY"
      )}&customerReportStatus=${status}&datacenterIds=${state.searchObj.datacenterIds.includes("all") ? [] : state.searchObj.datacenterIds.join(",")}&fromDashboard=${true}`
    );
  };

  const disabledViewCustomers = () => {
    let isDisabled = false;
    if (tokenData.isAdmin && (tokenData.role === 0 || tokenData.role === 5) && !state.searchObj.cemIds.includes("all")) isDisabled = true;
    if (tokenData.role === 2 && !state.searchObj.cemIds.includes(tokenData._id)) isDisabled = true;
    return isDisabled;
  }

  return (
    <React.Fragment>
      {/* {state.isLoading && <Loading isModeless={true} />} */}
      <div style={wrapperStyles}>
        <div className="ms-Grid p-0">
          <div className="ms-Grid-row ms-motion-scaleDownIn status-count-card position-relative overflow ml-0 mr-0">
            {state.isLoading && (
              <div className="custom-card spinner-center">
                <Spinner
                  size={SpinnerSize.large}
                // label="Loading"
                // labelPosition="bottom"
                />
              </div>
            )}
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12">
              <Stack
                horizontal
                horizontalAlign="space-between"
                wrap
                tokens={childrenGap}
              >
                <Stack.Item>
                  <Text className="dashboard-card-title">Customer Report</Text>
                </Stack.Item>
                <Stack.Item>
                  <Stack horizontal wrap tokens={childrenGap}>
                    {tokenData.isAdmin && [0, 2, 5].includes(tokenData.role) && (
                      <Stack.Item>
                        <Dropdown
                          selectedKey={state.searchObj.cemIds.length > 0 ? state.searchObj.cemIds[0] : ""}
                          styles={{ dropdown: { width: 170 } }}
                          options={state.cemUserOptions}
                          onChange={async (e, v: IDropdownOption | undefined) => {
                            if (v) {
                              let cemIds: string[] = [];
                              cemIds.push(v.key as string);
                              let obj = {
                                ...state,
                                searchObj: {
                                  ...state.searchObj,
                                  cemIds,
                                },
                              };
                              await getCustomerReportStatus(obj as any);
                            }
                          }}
                        />
                      </Stack.Item>
                    )}
                    <Stack.Item>
                      <Dropdown
                        selectedKey={state.selectedDatacenter}
                        styles={{ dropdown: { width: 150 } }}
                        options={state.datacenterOptions}
                        onChange={async (e, v: IDropdownOption | undefined) => {
                          if (v) {
                            let datacenterIds: string[] = [];
                            datacenterIds.push(v.key as string);
                            let obj = {
                              ...state,
                              selectedDatacenter: v.key as string,
                              searchObj: {
                                ...state.searchObj,
                                datacenterIds,
                              },
                            };
                            // setState();
                            await getCustomerReportStatus(obj as any);
                          }
                        }}
                      />
                    </Stack.Item>
                    <Stack.Item>
                      <div
                        ref={(calendarBtn) =>
                          (calendarButtonElement = calendarBtn!)
                        }
                      >
                        <DefaultButton
                          text={
                            !state.searchObj.date
                              ? "Select a month"
                              : moment(state.searchObj.date).format("MMM-YYYY")
                          }
                          onClick={() =>
                            setState({ ...state, showCallender: true })
                          }
                          className="month-picker-btn"
                        />
                      </div>
                      {state.showCallender && (
                        <Callout
                          isBeakVisible={false}
                          // className="ms-DatePicker-callout"
                          gapSpace={0}
                          doNotLayer={false}
                          target={calendarButtonElement}
                          directionalHint={DirectionalHint.bottomLeftEdge}
                          onDismiss={() => closeCallender()}
                          setInitialFocus
                        >
                          <FocusTrapZone
                            firstFocusableSelector="ms-DatePicker-day--today"
                            isClickableOutsideFocusTrap
                          >
                            <Calendar
                              // eslint-disable-next-line react/jsx-no-bind
                              onSelectDate={async (
                                date: Date | null | undefined
                              ) => {
                                // setState()
                                let obj = {
                                  ...state,
                                  searchObj: {
                                    ...state.searchObj,
                                    date: date as Date,
                                  },
                                  showCallender: false,
                                };
                                await getCustomerReportStatus(obj);
                              }}
                              onDismiss={() => closeCallender()}
                              isMonthPickerVisible={true}
                              value={new Date(state.searchObj.date)}
                              firstDayOfWeek={DayOfWeek.Sunday}
                              strings={DayPickerStrings}
                              isDayPickerVisible={false}
                              highlightCurrentMonth={false}
                              highlightSelectedMonth={true}
                              showMonthPickerAsOverlay={false}
                              showGoToToday={false}
                              maxDate={new Date(Date.now())}
                            />
                          </FocusTrapZone>
                        </Callout>
                      )}
                    </Stack.Item>
                  </Stack>
                </Stack.Item>
              </Stack>
              <hr />
              <div className="ms-Grid-row">
                <div className="ms-Grid-col pt-0 ms-sm12 ms-md12 ms-lg9">
                  <div className="ms-Grid-row">
                    {state.customerReportStatus.count.map((item, index) => (
                      <div
                        className="ms-Grid-col ms-sm12 ms-md12 ms-lg6 ms-xl6"
                        key={index}
                      >
                        <div onClick={() => disabledViewCustomers() ? undefined : viewCustomers(item._id)}>
                          <ReportStatusCard
                            status={item._id}
                            count={item.count}
                            isReportStatus={true}
                            isReportStatusClickDisabled={disabledViewCustomers()}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="ms-Grid-col pt-8 ms-sm12 ms-md12 ms-lg3">
                  <div onClick={() => disabledViewCustomers() ? undefined : viewCustomers(10)}>
                    <ReportStatusCard
                      status={10}
                      count={state.customerReportStatus.totalReport}
                      isReportStatus={true}
                      isReportStatusClickDisabled={disabledViewCustomers()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReportStatusDashboard;
